import { render } from "./DynvibeBubble.vue?vue&type=template&id=91c970ea"
import script from "./DynvibeBubble.vue?vue&type=script&lang=js"
export * from "./DynvibeBubble.vue?vue&type=script&lang=js"

import "./DynvibeBubble.vue?vue&type=style&index=0&id=91c970ea&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__